import {
	Mail,
	User,
	Briefcase,
	HardDrive,
	BookOpen,
	Terminal,
	Info,
} from "react-feather";
import {
	FaPeopleArrows,
	FaNetworkWired,
	FaFileAlt,
	FaEnvelope,
} from "react-icons/fa";

export const MENUITEMS = [
	{
		menucontent: "Dashboards,Widgets",
		Items: [
			{
				title: "Candidates",
				icon: User,
				type: "sub",
				active: false,
				children: [
					{
						path: `${process.env.PUBLIC_URL}/View-Candidates`,
						title: "View Candidates",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/Add-Candidates`,
						title: "Add Candidate",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/Bookmarked-Candidates`,
						title: "Bookmarked",
						type: "link",
					},
				],
			},
			{
				title: "Jobs",
				icon: Briefcase,
				type: "sub",
				active: false,
				children: [
					{
						path: `${process.env.PUBLIC_URL}/View-Jobs`,
						title: "View Jobs",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/AddNewJob`,
						title: "Add Job",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/Job-List`,
						title: "View Applicants",
						type: "link",
					},
				],
			},
			{
				title: "Tests",
				icon: Terminal,
				type: "sub",
				active: false,
				children: [
					{
						path: `${process.env.PUBLIC_URL}/View-Tests`,
						title: "View Tests",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/Create-Test`,
						title: "Add Test",
						type: "link",
					},
				],
			},
			{
				title: "News",
				icon: BookOpen,
				type: "sub",
				active: false,
				children: [
					{
						path: `${process.env.PUBLIC_URL}/ViewNewsCategories`,
						title: "Categories",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/ViewNewsProvider`,
						title: "Provider",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/ViewNewsFeeds`,
						title: "Feeds",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/ViewNewsCategoryTag`,
						title: "Tags",
						type: "link",
					},
				],
			},
			{
				title: "Bulletin",
				icon: Mail,
				type: "sub",
				active: false,
				children: [
					{
						path: `${process.env.PUBLIC_URL}/Bulletin`,
						title: "Post Bulletin",
						type: "link",
						icon: Mail,
					},
					{
						path: `${process.env.PUBLIC_URL}/View-Bulletin`,
						title: "View Bulletins",
						type: "link",
						icon: Mail,
					},
				],
			},
			{
				title: "Company Data",
				icon: Info,
				type: "sub",
				active: false,
				children: [
					{
						path: `Edit-Profile`,
						title: "Company Profile",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/ViewRecruitContact/:companyID`,
						title: "Users",
						type: "link",
					},
				],
			},
			{
				title: "Master Data",
				icon: HardDrive,
				type: "sub",
				active: false,
				children: [
					{
						path: `${process.env.PUBLIC_URL}/skills`,
						title: "Skills",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/MustHaves`,
						title: "Mandatory ",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/View-Badges`,
						title: "Badges",
						type: "link",
					},
					{
						path: `${process.env.PUBLIC_URL}/ViewCandidateQuestionTemplates`,
						title: "Templates",
						type: "link",
					},
				],
			},
		],
	},
];
